<!-- payment-form -->

<form action="" id="payment-form" style="position: relative" [formGroup]="creditCardForm" fxLayout="column" class="pd-30 h100">
    <mat-form-field appearance="outline">
        <mat-label>{{ "CREDIT_CARDS" | translate }}</mat-label>
        <mat-select formControlName="cardList">
            <mat-select-trigger>************{{selectedPaymentMethod?.card.last4}}</mat-select-trigger>

            <mat-option *ngFor="let paymentMethod of paymentMethods | async" [value]="paymentMethod">
                <div class="" fxLayout="row" fxLayoutAlign="space-between start">
                    <span>************{{ paymentMethod.card.last4 }}</span>


                </div>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <div id="card-element">
        <!--Stripe.js injects the Card Element-->
    </div>

    <div class="" fxFlex></div>

    <app-order-details-total *ngIf="
      !checkoutService.createSavingPlanTypes.includes(
        (checkoutService.selectedPaymentRequest | async)?.type
      )
    " style="margin-bottom: 30px" [shippingPrice]="checkoutService.shippingPrice | async" [totalPrice]="checkoutService.totalPrice | async" [taxIncludes]="true" [showDeliveryPrice]="
      checkoutService.redirectToPaymentList.includes(
        (checkoutService.selectedPaymentRequest | async)?.type
      )
    "></app-order-details-total>

    <button type="submit" id="submit" class="my-button" color="primary" mat-flat-button [disabled]="loading">
    <span *ngIf="!loading" id="button-text">{{ "PAY" | translate }}</span>
  </button>
    <mat-spinner *ngIf="loading" class="spinner"></mat-spinner>
</form>
